import { ServerModels as SM } from 'types/server';

export const sortingDirectionMap = {
  ASC: SM.SortingDirection.Asc,
  DESC: SM.SortingDirection.Desc,
};
